import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to clear assets tab state when navigating away from assets routes
 */
export const useAssetsTabCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    const isAssetsRoute = location.pathname.startsWith('/assets');
    if (!isAssetsRoute) {
      localStorage.removeItem('assets-selected-tab');
    }
  }, [location.pathname]);
};
